import { useQuery } from '@tanstack/react-query';
import { WithQueryStatus } from '../../../types/withQueryStatus';
import { IService } from '@clickersphere/core/entities/IService';
import ServiceService from '@clickersphere/core/services/ServiceService';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { useUserMe } from '../user/useUserMe';

export const SERVICES_QUERY_KEY = 'services';

export type ServiceQueryData = WithQueryStatus<IService>;

export function useServices() {
  const { selectedTenantId } = useUserMe();
  const { buildQueryKey } = useBuildQueryKey();

  const {
    data: services,
    isSuccess: isServicesSuccess,
    isFetching: isServicesFetching,
    isLoading: isServicesLoading,
  } = useQuery({
    staleTime: 1000 * 60 * 5,
    enabled: !!selectedTenantId,
    queryKey: buildQueryKey(SERVICES_QUERY_KEY),
    queryFn: async () => {
      const data = await ServiceService.getAll();
      return data as ServiceQueryData[];
    },
    select: (data) => data.sort((a, b) => (a.name > b.name ? 1 : -1)),
  });

  return {
    services,
    isServicesSuccess,
    isServicesFetching,
    isServicesLoading,
  };
}
